import React from 'react';
import { Search } from '@naf-simba/building-blocks-icons/General';
import { Loader } from '@naf-simba/building-blocks-loaders';
import LogoArea from '../LogoArea/LogoArea';
import MemberArea from '../MemberArea/MemberArea';
import { SpinnerWrapper } from '../../spinner/Styles';
import { NavbarProps } from '../Navbar.types';
import * as S from './MobileNavbar.styles';

const MobileNavbar = ({
  onNavClick,
  onHamburgerMenuClick,
  onProfileMenuClick,
  onSearchClick,
  showProfileMenu,
  setShowProfileMenu,
  isAuthenticated,
  isMyNAFEnabled,
  isLoading,
  isSearchEnabled,
  accountName,
  isMenuOpen,
}: NavbarProps) => (
  <S.TopBarMobile $isMenuOpen={isMenuOpen}>
    <S.MobileTopBarInline $isMenuOpen={isMenuOpen}>
      <LogoArea onNavClick={onNavClick} />
      <S.MobileMenuButtonsWrapper>
        {isSearchEnabled && (
          <S.SearchButton
            type="button"
            aria-label="Søk"
            onClick={onSearchClick}
            size="small"
            startIcon={Search}
            textWrap="nowrap"
          >
            Søk
          </S.SearchButton>
        )}
        {isLoading ? (
          <SpinnerWrapper>
            <Loader size="small" />
          </SpinnerWrapper>
        ) : (
          <MemberArea
            accountName={accountName}
            onProfileMenuClick={onProfileMenuClick}
            showProfileMenu={showProfileMenu}
            setShowProfileMenu={setShowProfileMenu}
            isAuthenticated={isAuthenticated}
            isMyNafEnabled={isMyNAFEnabled}
            isLoading={isLoading}
          />
        )}
        <S.StyledMenuButton ariaLabel="Hovedmeny" onClick={onHamburgerMenuClick} isOpen={isMenuOpen} />
      </S.MobileMenuButtonsWrapper>
    </S.MobileTopBarInline>
  </S.TopBarMobile>
);

export default MobileNavbar;
